import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getBCTbRows,
  setIsAddSubGroupLabel3Modal,
  updateGroupings,
  singleNotesData,
  updateLedgers
} from "../../../redux/actions/BookClosure/actionBookClosure";
import AddSubGroupLabel3Modal from "./AddSubGroupLabel3Modal";
import { useParams } from "react-router";
import { mapLedger } from "../../Services/ApiHandler";
import swal from "sweetalert";
import { toast } from "react-toastify";

import { formatAmount } from "../../../utils/formatAmount";
import tablecss from "../../../myfin_v2/css/table.module.css";
import commoncss from "../../../myfin_v2/css/common.module.css";

const ThirdLabelData = ({ dragData, financialYearStartFormatted, asOnDateFormatted }) => {
  const dispatch = useDispatch();
  const { bookClosureTbId } = useParams();

  const { thirdLabelData } = useSelector(
    (initialState) => initialState.BookClosureTbcReducer
  );
  
  const { mappingChecked } = useSelector((state) => state.BookClosureReducer);

  const [addSubGroupRrquirement, setAddSubGroupRrquirement] = useState({
    level: null,
    levelOneName: "",
    levelTwoName: "",
  });

  const OnDropItem = async (e, subGrp, targetColumn) => {
    e.preventDefault();

    // Parse dragged ledgers
    let draggedLedgers = dragData;
    try {
      const data = e.dataTransfer.getData("application/json");
      if (data) draggedLedgers = JSON.parse(data);
    } catch (err) {
      console.error(err);
    }

    if (!draggedLedgers || draggedLedgers.length === 0) return;

    // Prepare payload for backend based on targetColumn
    const payload = draggedLedgers.map((ledger) => ({
      ledgerID: ledger._id,
      ...(mappingChecked && targetColumn === "CY"
        ? {
            FSGroupCY: thirdLabelData?.groupCatName,
            notesGroupCY: thirdLabelData?.name,
            subGroupCY: subGrp?.name,
          }
        : {}),
      ...(mappingChecked && targetColumn === "PY"
        ? {
            FSGroupPY: thirdLabelData?.groupCatName,
            notesGroupPY: thirdLabelData?.name,
            subGroupPY: subGrp?.name,
          }
        : {}),
      ...(!mappingChecked
        ? {
            FSGroupCY: thirdLabelData?.groupCatName,
            notesGroupCY: thirdLabelData?.name,
            subGroupCY: subGrp?.name,
            FSGroupPY: thirdLabelData?.groupCatName,
            notesGroupPY: thirdLabelData?.name,
            subGroupPY: subGrp?.name,
          }
        : {}),
    }));

    try {
      const response = await mapLedger(bookClosureTbId, { ledgers: payload });

      dispatch(updateGroupings(response.data.updatedGroupings));
      dispatch(updateLedgers(response.data.updatedLedgers));

      const updatedGroup = response.data.updatedGroupings.find(
        grp => grp.name === thirdLabelData.groupCatName
      );

      if (updatedGroup && updatedGroup.subgroup && updatedGroup.subgroup.length > 0) {
        const targetSubgroup = updatedGroup.subgroup.find(
          sg => sg.name === thirdLabelData.name
        );

        if (targetSubgroup) {
          dispatch(singleNotesData({ 
            subGrp: targetSubgroup, 
            groupCatName: updatedGroup.name 
          }));
        }
      }

      toast.success(`${draggedLedgers.length} ledger(s) mapped successfully`);
    } catch (error) {
      swal(
        "Error",
        error?.response?.data?.error || "Mapping Ledger Failed!",
        "error"
      );
    }
  };


  const onDragOverItem = (e) => {
    e.preventDefault();
  };

  return (
    <>
      <div className={tablecss.tableContainer}>
        <table className={tablecss.customTable} >
          <thead>
            <tr className="bg-secondary-400">
              <th> {`Particulars (${thirdLabelData?.name})`} </th>
              <th> {asOnDateFormatted ? `AS AT ${asOnDateFormatted}` : ''}</th>
              <th>{financialYearStartFormatted ? `AS AT ${financialYearStartFormatted}` : ''}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colSpan={3} className={`text-left pl-3 ${commoncss.highlightRow}`}>
                {" "}
                {thirdLabelData?.groupCatName}{" "}
              </td>
            </tr>
            {thirdLabelData && thirdLabelData?.subgroup.length > 0 ? (
              thirdLabelData?.subgroup.map((subGrp, sx) => (
                <React.Fragment key={sx}>
                  <tr
                    onDragOver={onDragOverItem}
                    // onDrop={(e) => OnDropItem(e, subGrp)}
                  >
                    <td
                      className="text-left pl-3"
                      onDrop={(e) => OnDropItem(e, subGrp, "CY")}
                    >
                      {" "}
                      {subGrp?.name}{" "}
                    </td>
                    <td
                      className="text-right pr-3"
                      onDrop={(e) => OnDropItem(e, subGrp, "CY")}
                    >
                      {" "}
                      {formatAmount(subGrp?.currentYearAmount)}{" "}
                    </td>
                    <td
                      className="text-right pr-3"
                      onDrop={(e) => OnDropItem(e, subGrp, "PY")}
                    >
                      {" "}
                      {formatAmount(subGrp?.previousYearAmount)}{" "}
                    </td>
                  </tr>
                  {sx === thirdLabelData?.subgroup.length - 1 && (
                    <>
                      <tr>
                        <td className="text-left pl-3 custom-bg-gray-200">
                          {" "}
                          Total{" "}
                        </td>
                        <td className="text-right pr-3 custom-bg-gray-200">
                          {" "}
                          {}{" "}
                        </td>
                        <td className="text-right pr-3 custom-bg-gray-200">
                          {" "}
                          {}{" "}
                        </td>
                      </tr>
                      <tr>
                        <td
                          colSpan={3}
                          className={`text-left pl-3cursor-pointer ${commoncss.primaryLable}`}
                          onClick={() => {
                            setAddSubGroupRrquirement((prev) => ({
                              ...prev,
                              level: subGrp?.level,
                              levelOneName: thirdLabelData?.groupCatName,
                              levelTwoName: thirdLabelData?.name,
                            }));
                            dispatch(setIsAddSubGroupLabel3Modal(true));
                          }}
                        >
                          + Add sub group
                        </td>
                      </tr>
                    </>
                  )}
                </React.Fragment>
              ))
            ) : (
              // <td colSpan={3}> Please add level 3 to map your ledgers </td>
              <tr>
                <td colSpan={3}
                    className={`text-left pl-3 cursor-pointer ${commoncss.primaryLable}`}
                    onClick={() => {
                      setAddSubGroupRrquirement({
                        level: 3,
                        levelOneName: thirdLabelData?.groupCatName,
                        levelTwoName: thirdLabelData?.name,
                      });
                      dispatch(setIsAddSubGroupLabel3Modal(true));
                    }}>
                  + Add sub group
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <AddSubGroupLabel3Modal
        requirements={addSubGroupRrquirement}
        setRequirements={() =>
          setAddSubGroupRrquirement({
            ...addSubGroupRrquirement,
            level: null,
            levelOneName: "",
            levelTwoName: "",
          })
        }
      />
    </>
  );
};

export default ThirdLabelData;
